import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";
import { groupColors } from "@/modules/theme/utils/groupColors";

export const createCustomOptionLabelStyles = ({
  theme: { spacing, typography },
  color,
}: {
  theme: Theme;
  color: string;
}) => {
  const backgroundColor = groupColors.find((current) => current.color === color)
    ?.backgroundColor;

  return {
    root: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }),
    text: css({
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textAlign: "center",
      width: "100%",
      color,
      backgroundColor,
      lineHeight: typography.fontSize.large,
      height: 20,
      borderRadius: 10,
      padding: spacing([0.25, 1]),
    }),
  };
};
